"use client";

import { usePostPrayer } from "@packages/media";
import type { Prayer } from "@packages/sdk";
import { useEffect } from "react";

import { useJournalEditor } from "./useJournalEditor";

export const EstablishPostPrayerJournal = () => {
  const { setOnReflect } = usePostPrayer();
  const { show, showToast, toast } = useJournalEditor();

  const handleReflect = ({ prayer }: { prayer?: Prayer }) => show({ prayer });

  useEffect(() => {
    setOnReflect(() => handleReflect);
  }, []);

  return showToast ? toast : null;
};
